import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ApiHandler from './ApiHandler'
import vuetify from './plugins/vuetify'
Vue.prototype.$api = new ApiHandler();
import Dayjs from 'vue-dayjs';

Vue.config.productionTip = false

Vue.use(Dayjs, {
  lang:  'nl',
  filters: {
    ago: 'ago',
  },
  directives: {
    countdown: 'countdown',
  }
});

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
